import { find, get } from 'lodash';

function getGroup(state, id) {
  return find(get(state, 'groups.data', []), { id });
}

export default getGroup;
